import React from 'react';

const CHIPS = [
  ['', 'All deals', 'bg-[#00E676]/15 text-[#00E676] border-[#00E676]/40'],
  ['pro', 'Pro deals', 'bg-[#00E5FF]/15 text-[#00E5FF] border-[#00E5FF]/40'],
  ['elite', 'Elite exclusives', 'bg-[#FFD740]/15 text-[#FFD740] border-[#FFD740]/40'],
];

export function DealChips({ value, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4 sm:mb-6" data-testid="tier-filter-chips">
      {CHIPS.map(([k, label, active]) => (
        <button key={k || 'all'} type="button" onClick={() => onChange(value === k ? '' : k)}
          className={`h-8 px-3.5 rounded-full text-xs font-medium border transition-colors ${value === k ? active : 'bg-transparent text-[#A0B4CC] border-white/10 hover:border-white/20'}`}
          data-testid={`tier-chip-${k || 'all'}`}>{label}</button>
      ))}
    </div>
  );
}
